/**
 * Shell do frontend - fonte UNICA de verdade
 * OP-20260810-004 (B2): dois shells por Host
 *
 * VITE_SHELL e definida INLINE na linha de build (Dockerfile), o que tem
 * precedencia sobre .env.production. Sem a variavel (dev, vitest, CI) o valor
 * resolvido e 'admin' - exatamente o comportamento historico do host legado
 * servido sob /admin/.
 *
 * - 'app'   -> App ERP        (erp.elohimtech.com.br)
 * - 'admin' -> Gestao SaaS    (admin.elohimtech.com.br e legado /admin/)
 *
 * NOTA: nao citar o dominio legado neste arquivo. Ele entra no sourcesContent
 * do sourcemap dos builds novos e sujaria a prova anti-vazamento (a URL
 * absoluta so pode aparecer no build legado, que a le do .env.production).
 */

export const SHELLS = Object.freeze({
  APP: 'app',
  ADMIN: 'admin'
})

/**
 * Resolve o shell a partir de um valor bruto (env, query, teste).
 * Qualquer valor diferente de 'app' cai no default 'admin'.
 *
 * @param {string|undefined} valor
 * @returns {string} 'app' | 'admin'
 */
export function resolveShell(valor) {
  return valor === SHELLS.APP ? SHELLS.APP : SHELLS.ADMIN
}

export const SHELL = resolveShell(import.meta.env.VITE_SHELL)
